import { useTranslation } from 'react-i18next';

const FEATURE_ITEMS = [
  { key: 'spreadsheet', icon: 'ri-table-line' },
  { key: 'review', icon: 'ri-star-line' },
  { key: 'shipping', icon: 'ri-truck-line' },
  { key: 'coupon', icon: 'ri-coupon-3-line' },
  { key: 'discount', icon: 'ri-price-tag-3-line' },
  { key: 'warehouse', icon: 'ri-building-2-line' },
  { key: 'legit', icon: 'ri-shield-check-line' },
  { key: 'safety', icon: 'ri-lock-line' },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section id="resources" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            {t('home.features.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            {t('home.features.subtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {FEATURE_ITEMS.map((item) => (
            <div
              key={item.key}
              className="p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-950">
                {t(`home.features.${item.key}.title`)}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {t(`home.features.${item.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}